module.exports = __webpack_public_path__ + "media/images/flags/flag_aus-ab87726707beaf7218f9f544ae55a02c.svg";